import { Component, OnDestroy, OnInit } from '@angular/core';
import { AuthService } from '@app/@core/services/auth.service';
import { PermissionStore } from '@app/@core/store/permission.store';
import { environment } from '@env/environment';
import { BehaviorSubject, Subscription } from 'rxjs';
import { HttpService } from '@app/@core/services/http.service';
import { AppConstants } from '@app/@core/entities/app-constants';
import { FormGroup } from '@angular/forms';
import { LocalService } from '@core/services/local.service';

declare const _$: any;

@Component({
  standalone: false,
  selector: 'app-migrateuser',
  templateUrl: './migrateuser.component.html',
  styleUrls: ['./migrateuser.component.scss']
})
export class MigrateUserComponent implements OnInit, OnDestroy {
  RBACORG: any;
  PERMISSION: any;
  orgSubs: Subscription;
  groupEvent$: BehaviorSubject<any>;
  INPUTVALIDATIONMETHOD: any;

  pageList: any;
  itemsPageList: any;
  totalcount = 0;
  itemtotalcount = 0;
  updateGrid: any;
  tableColumns: any;
  itemtableColumns: any;
  filterOptions: any[];
  fileUploadUrl: string;
  gridOptions: { value: string; label: string; code: string }[];
  filterForm!: FormGroup;
  itemfilterOptions: any[];
  itemfilterForm!: FormGroup;
  localstore: LocalService;
  file: any;
  imageName: any;
  urlGet: any;
  userRole: string;

  constructor(private permissionStore: PermissionStore, private authService: AuthService, private httpService: HttpService, private sessionStorage: LocalService) {
    // constructor(private permissionStore: PermissionStore, private authService: AuthService) {
    this.groupEvent$ = new BehaviorSubject<any>(null);
    this.orgSubs = this.authService.orgInfo.subscribe(o => {
      console.log('PermissionsComponent');
      this.INPUTVALIDATIONMETHOD = AppConstants.onInput.bind(this);
      this.PERMISSION = this.permissionStore.state;
      this.RBACORG = {
        tokenKey: 'jwt-token',
        apiHost: environment.apiHost,
        others: this.sessionStorage.asStorage(),
        orgID: o ? o : this.sessionStorage.getItem('orgid'),
        environment: {
          mstrUsername: environment.mstrUsername,
          mstrPassword: environment.mstrPassword,
          mstrURL: environment.mstrURL,
          mstrProjectID: environment.mstrProjectID,
          applicationid: environment.applicationid,
          priority: environment.priority,
          videoConferenceDomain: environment.videoConferenceDomain,
          ChatBotNew: environment.ChatBotNew,
          ChatBot: environment.ChatBot,
          n8nWorflowUrl: environment.n8nWorflowUrl,
          production: environment.production
        }
      };
      this.groupEvent$.next({
        RBACORG: this.RBACORG,
        PERMISSION: this.PERMISSION,
        httpService: this.httpService,
        INPUTVALIDATIONMETHOD: this.INPUTVALIDATIONMETHOD
      });
    });
  }

  ngOnInit(): void {
    console.log();
  }
  // eslint-disable-next-line @angular-eslint/use-lifecycle-interface
  ngOnDestroy(): void {
    this.orgSubs.unsubscribe();
  }
}
